export enum ClubDatesFilter {
  AllImportantDates = 'all-important-dates',
  Birthdays = 'birthdays',
  Jubilees = 'jubilees',
}
